import { memo } from 'react';
import { Wifi, WifiOff } from 'lucide-react';
import { useConnectionQuality } from '@/hooks/useConnectionQuality';
import { cn } from '@/lib/utils';

/**
 * ConnectionIndicator - Visual badge for connection quality
 * Only shows when connection is not 'strong' (doesn't clutter UI when OK)
 */
export const ConnectionIndicator = memo(() => {
  const { quality } = useConnectionQuality();

  // Don't show when connection is strong
  if (quality === 'strong') return null;

  return (
    <div className={cn(
      "fixed top-16 left-1/2 -translate-x-1/2 z-50 px-3 py-1.5 rounded-full text-xs font-medium shadow-lg flex items-center gap-1.5 animate-in fade-in slide-in-from-top-2 duration-300",
      quality === 'offline' && "bg-destructive text-destructive-foreground",
      quality === 'weak' && "bg-yellow-500/90 text-yellow-950",
      quality === 'medium' && "bg-blue-500/80 text-white"
    )}>
      {quality === 'offline' ? <WifiOff className="w-3 h-3" /> : <Wifi className="w-3 h-3" />}
      {quality === 'offline' && "Sem conexão"}
      {quality === 'weak' && "Conexão lenta"}
      {quality === 'medium' && "Conexão instável"}
    </div>
  );
});
ConnectionIndicator.displayName = 'ConnectionIndicator';
